import { Button, Form, Input, Modal, Select } from 'antd'
import React from 'react'
import { toast } from 'react-toastify';
import axiosInstance from '../../../variables/api/axiosInstance';

const EditUtilisateur = ({ editModalOpen, setEditModalOpen, utilisateur, form, requireActive, navigate, buttonStyle, primaryButtonStyle }) => {
    const [loading, setLoading] = React.useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (requireActive("modifier un utilisateur")) return;
        setLoading(true);

        const values = await form.validateFields();

        const updatedData = {
            ...utilisateur,
            personne: {
                ...utilisateur.personne,
                nom: values.nom || utilisateur.personne.nom,
                prenom: values.prenom || utilisateur.personne.prenom,
                genre: values.genre || utilisateur.personne.genre,
                adresse: values.adresse || utilisateur.personne.adresse,
                fonction: values.fonction || utilisateur.personne.fonction,
            },
            email: values.email || utilisateur.email,
        };
        console.log(updatedData)
        axiosInstance
            .put(`/api/utilisateur`, updatedData)
            .then((res) => {
                toast.success("Utilisateur modifié avec succès");
                setLoading(false)
                setEditModalOpen(false)
                // La modification historise l'utilisateur → NOUVEAU codeId. On redirige vers
                // ce nouveau codeId (l'ancien devient inactif). Garde-fou si absent.
                const newCodeId = res?.data?.codeId;
                if (newCodeId) {
                    navigate(`/details-utilisateur/${newCodeId}`, { replace: true });
                }
            })
            .catch((err) => {
                console.error(err);
                setLoading(false)

                toast.error("Erreur lors de la modification des informations");
            })
            .finally(() => setLoading(false));
    };

    return (
        <Modal
            open={editModalOpen}
            onCancel={() => setEditModalOpen(false)}
            footer={null}
            width={700}
            style={{ top: 20 }}
        >
            <div style={{ padding: '24px 0' }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#242166', marginBottom: '8px' }}>
                        Éditer l'utilisateur
                    </h2>
                    <p style={{ color: '#6B7280', fontSize: '14px' }}>
                        Mise à jour des informations personnelles
                    </p>
                </div>

                <Form form={form} layout="vertical">
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0px 22px' }}>
                        <Form.Item name={"nom"} label={<span style={{ color: '#242166', fontWeight: '600' }}>Nom</span>}>
                            <Input
                                placeholder="Nom de famille"
                                defaultValue={utilisateur?.personne?.nom}
                                style={{ borderRadius: '8px' }}
                            />
                        </Form.Item>

                        <Form.Item name={"prenom"} label={<span style={{ color: '#242166', fontWeight: '600' }}>Prénom</span>}>
                            <Input
                                placeholder="Prénom(s)"
                                defaultValue={utilisateur?.personne?.prenom}
                                style={{ borderRadius: '8px' }}
                            />
                        </Form.Item>

                        <Form.Item name={"genre"} label={<span style={{ color: '#242166', fontWeight: '600' }}>Genre</span>}>
                            <Select
                                defaultValue={utilisateur?.personne?.genre}
                                style={{ borderRadius: '8px' }}
                                options={[
                                    { value: 'MASCULIN', label: 'Masculin' },
                                    { value: 'FEMININ', label: 'Féminin' }
                                ]}
                            />
                        </Form.Item>

                        <Form.Item name={"email"} label={<span style={{ color: '#242166', fontWeight: '600' }}>Email</span>}>
                            <Input
                                type="email"
                                placeholder="email@example.com"
                                defaultValue={utilisateur?.email}
                                style={{ borderRadius: '8px' }}
                            />
                        </Form.Item>

                        <Form.Item name={"fonction"} label={<span style={{ color: '#242166', fontWeight: '600' }}>Fonction</span>}>
                            <Input
                                placeholder="Fonction"
                                defaultValue={utilisateur?.personne?.fonction}
                                style={{ borderRadius: '8px' }}
                            />
                        </Form.Item>

                        <Form.Item name="adresse" label={<span style={{ color: '#242166', fontWeight: '600' }}>Adresse</span>}>
                            <Input
                                placeholder="Adresse complète"
                                defaultValue={utilisateur?.personne?.adresse}
                                style={{ borderRadius: '8px' }}
                            />
                        </Form.Item>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '32px' }}>
                        <Button
                            onClick={() => setEditModalOpen(false)}
                            style={{ ...buttonStyle, minWidth: '120px' }}
                        >
                            Annuler
                        </Button>
                        <Button
                            type="primary"
                            style={{ ...primaryButtonStyle, minWidth: '120px' }}
                            loading={loading}
                            onClick={(e) => handleSubmit(e)}
                        >
                            Confirmer
                        </Button>
                    </div>
                </Form>
            </div>
        </Modal>
    )
}

export default EditUtilisateur